import React, { PureComponent } from 'react';
import { FormattedMessage } from 'react-intl';
import { TextField, Button, ErrorMessage } from '@atoms';
import { UtilityPageTemplate } from '@templates';
import messages from './messages';

export class TwoFactorAuthPage extends PureComponent {
  state = {
    inputValue: '',
  };

  handleSubmit = (e) => {
    e.preventDefault();
    this.props.confirmOTP({
      otp: e.target.otp.value,
      uuid: this.uuid,
      id: this.id,
      isAIRoute: this.isAIRoute,
    });
  };

  onChange = (event) => {
    const regex = /^[0-9\b]+$/;
    const { value } = event.target;

    if (value === '' || regex.test(value)) {
      this.setState({ inputValue: value });
    }
  };

  componentDidMount() {
    const params = new URL(window.location.href).searchParams;
    // This section is not tested
    // searchParams could not be mocked in needed way
    if (params) {
      this.uuid = params.get('uuid');
      this.id = params.get('id');
      this.isAIRoute = params.get('type') === 'ai-route';

      this.uuid && this.props.getTranscriptByLinksUUID(this.uuid, this.isAIRoute);
      this.id && this.props.getTranscriptEntryById(this.id, this.isAIRoute);
    }
  }

  render() {
    const { attemptsCountExhausted } = this.props;

    return (
      <UtilityPageTemplate title={<FormattedMessage {...messages.title} />}>
        {attemptsCountExhausted ? (
          <ErrorMessage>
            <FormattedMessage {...messages.tooManyAttempts} />
          </ErrorMessage>
        ) : (
          <FormattedMessage {...messages.enterCode} />
        )}
        <form onSubmit={this.handleSubmit}>
          <TextField
            id="access-code"
            name="otp"
            title="Access Code"
            type="password"
            required
            floatingLabelText="Access Code"
            value={this.state.inputValue}
            onChange={this.onChange}
            disabled={this.props.twoFactorAuthBlocked}
          />
          <Button
            primary={!this.props.twoFactorAuthBlocked}
            type="submit"
            id="submit"
            fullWidth
            disabled={this.props.twoFactorAuthBlocked}
            style={{ marginBottom: 14 }}
          >
            <FormattedMessage {...messages.submit} />
          </Button>
          <Button
            type="button"
            id="requestNewOTP"
            fullWidth
            onClick={() => {
              this.props.requestNewOTP({ uuid: this.uuid, id: this.id });
            }}
            disabled={this.props.twoFactorAuthBlocked}
          >
            <FormattedMessage {...messages.requestNewOTP} />
          </Button>
        </form>
      </UtilityPageTemplate>
    );
  }
}



// WEBPACK FOOTER //
// ./components/pages/TwoFactorAuthPage/TwoFactorAuthPage.js